<template>
  <div id="router" :style="viewStyle">
    <div id="box" class="pa-5" style="margin-top:3%">
      <v-row class="pb-5">
        <v-icon class="ma-0 pa-0" size="30" style="color:#215DA7">mdi-menu-right</v-icon>
        <h4 class="DarkBlue pt-1" >合作備忘錄申請資訊</h4>
      </v-row>
      <v-row>
        <v-col class="col-2">
          <div class="text-right pt-2 pt14"><span class="start">*</span>學校類別</div>
        </v-col>
        <v-col class="col-9">
          <v-select class="text_field" dense background-color="white" outlined placeholder="請選擇" :items="collegeCategoryList" item-text="title" item-value="valuev" v-model="datasets.collegeCategory"></v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="col-2">
          <div class="text-right pt-2 pt14"><span class="start">*</span>申請學校名稱</div>
        </v-col>
        <v-col class="col-9">
          <v-autocomplete v-if="datasets.collegeCategory!='4'" class="text_field autocomplete" placeholder="請選擇"
          :items="schoolList" item-text="name" item-value="name" v-model="datasets.company"></v-autocomplete>
          <v-text-field v-if="datasets.collegeCategory=='4'" class="text_field" dense background-color="white" outlined placeholder="請輸入" v-model="datasets.company"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <div class="text-right pt-2 pt14"><span class="start">*</span>申請學校系所</div>
        </v-col>
        <v-col cols="9">
          <v-text-field class="text_field" dense background-color="white" outlined placeholder="請輸入" maxlength="50" v-model="datasets.dept"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <div class="text-right pt-2 pt14"><span class="start">*</span>立約人</div>
        </v-col>
        <v-col cols="9">
          <v-text-field class="text_field" dense background-color="white" outlined placeholder="請輸入" maxlength="50" v-model="datasets.contact"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <div class="text-right pt-2 pt14"><span class="start">*</span>代表人</div>
        </v-col>
        <v-col cols="9">
          <v-text-field class="text_field" dense background-color="white" outlined placeholder="請輸入" maxlength="50" v-model="datasets.contact1"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <div class="text-right pt-2 pt14"><span class="start">*</span>聯絡電話</div>
        </v-col>
        <v-col cols="9">
          <v-text-field class="text_field" dense background-color="white" outlined placeholder="02-0000-0000" maxlength="30" v-model="datasets.tel1"
          @keyup="datasets.tel1 = datasets.tel1.replace(/[\u4e00-\u9fa5]/ig,'') && datasets.tel1.toUpperCase(), datasets.tel1 = $Global.toCDB(datasets.tel1)"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <div class="text-right pt-2 pt14"><span class="start">*</span>行動電話</div>
        </v-col>
        <v-col cols="9">
          <v-text-field class="text_field" dense background-color="white" outlined placeholder="0900000000" maxlength="10" v-model="datasets.ctel1"
          @keyup="[datasets.ctel1= datasets.ctel1.replace(/\D/g,'')]"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <div class="text-right pt-2 pt14"><span class="start">*</span>聯絡地址</div>
        </v-col>
        <v-col cols="9">
          <v-text-field class="text_field" dense background-color="white" outlined placeholder="請輸入" maxlength="200" v-model="datasets.postAddress"
          @keyup="datasets.postAddress = $Global.toCDB(datasets.postAddress)"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <div class="text-right pt-2 pt14"><span class="start">*</span>執行單位</div>
        </v-col>
        <v-col cols="9">
          <v-text-field class="text_field" dense background-color="white" outlined placeholder="請輸入" maxlength="50" v-model="datasets.excuDept"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <div class="text-right pt-2 pt14"><span class="start">*</span>代表人</div>
        </v-col>
        <v-col cols="9">
          <v-text-field class="text_field" dense background-color="white" outlined placeholder="請輸入" maxlength="50" v-model="datasets.contact2"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <div class="text-right pt-2 pt14"><span class="start">*</span>聯絡電話</div>
        </v-col>
        <v-col cols="9">
          <v-text-field class="text_field" dense background-color="white" outlined placeholder="02-0000-0000" maxlength="30" v-model="datasets.tel2"
          @keyup="datasets.tel2 = datasets.tel2.replace(/[\u4e00-\u9fa5]/ig,'') && datasets.tel2.toUpperCase(), datasets.tel2 = $Global.toCDB(datasets.tel2)"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <div class="text-right pt-2 pt14"><span class="start">*</span>行動電話</div>
        </v-col>
        <v-col cols="9">
          <v-text-field class="text_field" dense background-color="white" outlined placeholder="0900000000" maxlength="10" v-model="datasets.ctel2"
          @keyup="[datasets.ctel2= datasets.ctel2.replace(/\D/g,'')]"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <div class="text-right pt-9 pt14"><span class="start">*</span>匯款資料</div>
        </v-col>
        <v-col cols="9">
          <v-radio-group class="ma-0 pa-0 language" dense v-model="datasets.pay">
            <v-row class="ma-0 pa-0 pt14" style="border-bottom: 1px solid #52575a">
              <v-radio value="1" color="#215DA7" style="margin-top:-10px">
                <template v-slot:label>
                  <span class="pt14" style="color:#000000">郵局</span>
                </template>
              </v-radio>
              <span class="pa-2" style="padding-top:2px">戶名</span>
              <v-text-field class="border pt14" outlined style="width:100px" :readonly="!(datasets.pay == 1)" :background-color="!(datasets.pay == 1)?'#F4F8F9':'#FFF'" maxlength="50" v-model="datasets.postPayName"></v-text-field>
              <span class="pa-2" style="padding-top:2px">局號</span>
              <v-text-field class="border pt14" outlined style="width:100px" :readonly="!(datasets.pay == 1)" :background-color="!(datasets.pay == 1)?'#F4F8F9':'#FFF'" maxlength="20" v-model="datasets.postBranch"></v-text-field>
              <span class="pa-2" style="padding-top:2px">帳號</span>
              <v-text-field class="border pt14" outlined style="width:140px" :readonly="!(datasets.pay == 1)" :background-color="!(datasets.pay == 1)?'#F4F8F9':'#FFF'" maxlength="20" v-model="datasets.postAccount"></v-text-field>
            </v-row> 
            <v-row class="ma-0 pa-0 pt-2 pt14">
              <v-radio value="2" color="#215DA7" style="margin-top:-10px">
                <template v-slot:label>
                <span class="pt14" style="color:#000000">銀行</span>
                </template>
              </v-radio>
              <span class="pa-2" style="padding-top:2px">戶名</span>
              <v-text-field class="border pt14 pr-2" outlined style="width:100px" :readonly="!(datasets.pay == 2)" :background-color="!(datasets.pay == 2)?'#F4F8F9':'#FFF'" maxlength="50" v-model="datasets.bankPayName"></v-text-field>
              <v-text-field class="border pt14" outlined style="width:100px" :readonly="!(datasets.pay == 2)" :background-color="!(datasets.pay == 2)?'#F4F8F9':'#FFF'" maxlength="50" v-model="datasets.bankName"></v-text-field>
              <span class="pa-2" style="padding-top:2px">銀行</span>
              <v-text-field class="border pt14" outlined style="width:100px" :readonly="!(datasets.pay == 2)" :background-color="!(datasets.pay == 2)?'#F4F8F9':'#FFF'" maxlength="20" v-model="datasets.bankBranch"></v-text-field>
              <span class="pa-2" style="padding-top:2px">分行</span>
              <span class="pa-2" style="padding-top:2px">帳號</span>
              <v-text-field class="border pt14" outlined style="width:140px" :readonly="!(datasets.pay == 2)" :background-color="!(datasets.pay == 2)?'#F4F8F9':'#FFF'" maxlength="50" v-model="datasets.bankAccount"></v-text-field>
            </v-row>
            <v-row class="ma-0 pa-0 pt14">
              <span class="pa-2" style="padding-top:2px">>>「戶名」必須與「立約人」或「代表人」相同</span>
            </v-row> 
          </v-radio-group>
        </v-col>
      </v-row> 
    </div>
    <!-- <VueLoadingButton aria-label="Post message" class="button disable mb-5 py-2 col-8 col-sm-5 col-md-4 col-lg-3" style="height:40px; background:#81c0e2; border-radius:8px; border:none"
      @click.native="newDataset()" :loading="isLoading">
      <span style="color:#FFFFFF; font-size: 0.9rem;">新增</span>
    </VueLoadingButton> -->
    <v-btn class="mb-5 col-8 col-sm-5 col-md-4 col-lg-3" outlined style="height:40px; background:#81c0e2; border-radius:8px; border:none" @click="newDataset()">
      <span style="color:#FFFFFF">新增</span>
    </v-btn>
    <ShowMsg ref="ShowMsg" :onSave="onShowMsg"/>
  </div>
</template>

<script>
import VueLoadingButton from 'vue-loading-button';
import ShowMsg from '@/dialogs/ShowMsg'
export default {
  name: 'Memorandum',
  components: {VueLoadingButton,ShowMsg},
  mounted(){
    this.$Global.getCollegeCategoryList().then(res=>{ this.collegeCategoryList = res })
    this.getDatasetForm()
  },
  data:() => ({
    datasets: [],
    viewStyle:{},
    isLoading: false,
    collegeCategoryList: [],
    schoolList: [],
    requiredField:['collegeCategory','company','dept','contact','contact1','tel1','ctel1','postAddress','excuDept','contact2','tel2','ctel2','pay'],
  }),
  created(){
    this.calculateWindows()
    this.$root.$on('windowInnerHeight',()=>{
      this.calculateWindows()
    })
  },
  watch:{
    "datasets.collegeCategory":function(){
      this.$Global.getSchoolList(this.datasets.collegeCategory, true).then(res=>{ this.schoolList = res })
    },
    "datasets.pay":function(){
      if(this.datasets.pay == 1){
        this.datasets.bankPayName = ''
        this.datasets.bankName = ''
        this.datasets.bankBranch = ''
        this.datasets.bankAccount = ''
        return
      }      
      if(this.datasets.pay == 2){
        this.datasets.postPayName = ''
        this.datasets.postBranch = ''
        this.datasets.postAccount = ''
        return
      }
    },
  },
  computed: {},
  methods:{
    calculateWindows(){
      this.viewStyle = {height: window.innerHeight-64 + 'px'}
    },
    redirectPath(path){
      this.$router.push(path)
    },
    getDatasetForm(){
      var self = this
      var request = {
        method: 'GET',
        url: '/erpComeMo/' + '1', //TBD
        params: {},
      }
      this.$http(request).then(function(response) {
        if(response.data.data == null){
          self.$refs.ShowMsg.open(0,'唯一值錯誤','請聯繫系統管理人員，編號為Mmd-7956')
        }else{
          self.datasets = response.data.data
        }
      }).catch(()=>{
        console.log('系統錯誤','請聯繫系統管理人員，編號為Mmd-7956')
      }).finally(()=>{
        for (var key in self.datasets) {
          self.datasets[key] = null;
        }
      })
    },
    newDataset() {
      if(!this.$Global.checkForm(this.datasets,this.requiredField)){
        this.$refs.ShowMsg.open(1)
        return
      }
      if(this.datasets.pay == 1 && (!this.datasets.postPayName || !this.datasets.postBranch || !this.datasets.postAccount)){
          this.$refs.ShowMsg.open(0,'請輸入所有必填','匯款資料請逐一填寫完成')
        return false
      }
      if(this.datasets.pay == 2 && (!this.datasets.bankPayName || !this.datasets.bankName || !this.datasets.bankBranch || !this.datasets.bankAccount)){
          this.$refs.ShowMsg.open(0,'請輸入所有必填','匯款資料請逐一填寫完成')
        return false
      }
      // this.isLoading = true;
      var allData = this.$Global.copy(this.datasets)
      allData = this.$Global.jsonConcat(allData,{'contractType':'3'})
      allData = this.$Global.jsonConcat(allData,{'status':'0'})
      allData = this.$Global.jsonConcat(allData,{'applicantIdCard':sessionStorage.getItem('cerpsMemberIdCard')})
      allData = this.$Global.jsonConcat(allData,{'applicantName':sessionStorage.getItem('cerpsMemberName')})
      allData = this.$Global.jsonConcat(allData,{'createId':sessionStorage.getItem('cerpsMemberIdCard')})
      var self = this
      var request = {
        method: 'POST',
        url: '/erpComeMo',
        data: this.Qs.stringify(allData),
      }
      this.$http(request).then(function(response) {
        // console.log(response)
        // setTimeout(() => (self.isLoading = false), 5000);
        self.$refs.ShowMsg.open(18,'','',true)
      }).catch(()=>{
        self.$refs.ShowMsg.open(0,'系統錯誤','請聯繫系統管理人員，編號為Mmd-7957')
      }).finally(()=>{
        // self.isLoading = false
      })
    },
    onShowMsg(){
      this.redirectPath('/registrationList')
    },
  }
}
</script>